/**
 * Returns a new array with the item at `from` moved to index `to`.
 * Never mutates the input. Out-of-range indexes (or from === to) are a no-op,
 * but a copy is still returned so callers can always treat the result as new state.
 */
export function moveItem<T>(arr: T[], from: number, to: number): T[] {
    const result = [...arr];

    const isOutOfRange = from < 0 || from >= arr.length || to < 0 || to >= arr.length;
    if (from === to || isOutOfRange) {
        return result;
    }

    const [item] = result.splice(from, 1);
    result.splice(to, 0, item);

    return result;
}
